




import { Component, Vue } from 'vue-property-decorator';
import CreateBankAccount from '@/components/bankAccount/create/CreateBankAccount.vue';

@Component({
  name: 'create-bank-account-view',
  components: {
    CreateBankAccount,
  },
})
export default class CreateBankAccountView extends Vue { }
